// extracted by mini-css-extract-plugin
export default {"searcher":"Search_searcher__KFFkr"};